const VuexTypes = Object.freeze({
  // TAGS_TREE: 'TAGS_TREE',

  TAGS_LOAD: 'TAGS_LOAD',
  TAGS_LOAD_ONE: 'TAGS_LOAD_ONE',
  TAGS_FLUSH: 'TAGS_FLUSH',

  TAGS_TREE_LOAD_DELAY: 'TAGS_TREE_LOAD_DELAY',
  TAGS_SEARCH_FLAT: 'TAGS_SEARCH_FLAT',
  TAGS_SEARCH_TREE: 'TAGS_SEARCH_TREE',
  TAGS_LOOKUP_PATH: 'TAGS_LOOKUP_PATH',
});

export default VuexTypes;
